import React from "react";
import { useTranslation } from 'react-i18next';

export default function ConfirmedView(props) {
    var convertStartDateFormat = props.startDate;
    var startDate = (new Date(convertStartDateFormat)).toLocaleString();
    var convertEndDateFormat = props.endtDate;
    var endDate = (new Date(convertEndDateFormat)).toLocaleString();
    return (
        <div className="limiter">
            <div className="container h-vh pl-0 pr-0">
                <div className="row justify-content-center h-100 ml-0 mr-0">
                    <div className="col-md-7 pl-0 pr-0">
                        <div className="logo-container text-center confirm">
                            <div className="text-right">
                                <button type="button" className="btn btn-secondary text-uppercase" onClick={props.logout}>Logout</button>
                            </div>
                            <img src={require('../assets/images/logo_white.svg')} alt="" />
                        </div>
                        <div className="card">
                            <div className="card-body text-center">
                                <h5 className="card-header text-white bg-success text-uppercase text-center">{props.sheetData.FreeRegConfirmed} {props.freeHours} {props.sheetData.Hours}</h5>
                                <h5 className="card-title"><i><img src={require('../assets/images/clock.svg')} alt="" /></i>{props.sheetData.FreeRegValidFrom}</h5>
                                <div className="start-end-time">
                                    <span>{props.sheetData.StartTime} <strong className="start">{startDate}</strong></span>
                                    <span>{props.sheetData.EndTime} <strong className="end">{endDate}</strong></span>
                                </div>
                                <hr />
                                <p className="card-text">{props.sheetData.Plate} <strong className="text-uppercase">{props.visitorPassModel.PlateNo}</strong></p>
                                <p className="card-text">{props.sheetData.Zone} <strong>{props.visitorPassConfirmation.ParkingZone}</strong></p>
                                <p className="card-text">{props.sheetData.IssuedAt} <strong>{startDate}</strong></p>
                            </div>
                            <div>
                                <button type="button" className="btn btn-primary download w-100" onClick={() => { props.resetForm() }}>{props.sheetData.Reset}</button>
                            </div>
                        </div>
                        <div className="copyright mt-5 text-center text-uppercase"><a href="https://blinkay.com/">© Blinkay</a> {(new Date().getFullYear())}. {props.sheetData.AllRightReserved}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}